/**
 * File: src/api/notifications/index.js
 * Layer: API Client
 * Description: Wraps notification-related API calls used by the candidate
 * portal and assessor evidence-request flows.
 */
import axios from 'utils/axios';

const NOTIFICATIONS_BASE_URL = '/api/notifications';

/**
 * Fetch the authenticated user's notifications.
 * @param {Object} [params={}] - Optional query parameters
 * @returns {Promise<Object>}
 */
export const getMyNotifications = async (params = {}) => {
    try {
        const result = await axios.get(`${NOTIFICATIONS_BASE_URL}/me`, { params });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to load notifications');
    }
};

/**
 * Mark one notification as read.
 * @param {string} id - Notification identifier
 * @returns {Promise<Object>}
 */
export const markNotificationRead = async (id) => {
    try {
        const result = await axios.patch(`${NOTIFICATIONS_BASE_URL}/${id}/read`);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to mark notification as read');
    }
};

/**
 * Create an additional-evidence notification for a candidate assessment.
 * @param {string} assessmentId - Candidate assessment identifier
 * @param {Object} data - Request payload
 * @returns {Promise<Object>}
 */
export const createAssessmentEvidenceRequest = async (assessmentId, data) => {
    try {
        const result = await axios.post(`${NOTIFICATIONS_BASE_URL}/assessment/${assessmentId}/request-additional-evidence`, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to create candidate notification');
    }
};
